import { service } from '@maia/task';
import { QueryOptions, queryOptions, useMutation } from '@tanstack/react-query';
import { queryClient } from '../../../main';
import { TaskDto } from '@maia/shared';

export function getTaskOptions(
  guid: string,
  initialData: QueryOptions<TaskDto>['initialData'] = undefined,
) {
  return queryOptions({
    queryKey: ['tasks', 'task', guid],
    queryFn: async () => await service.getTask(guid),
    initialData,
  });
}

type UsePostMessageParams = Omit<
  Parameters<typeof service.sendMessage>[number],
  'body' | 'attachments'
>;

type UsePostMessageMutationParams = Omit<
  Parameters<typeof service.sendMessage>[number],
  'customerGuid' | 'taskGuid'
>;

export function usePostMessage({
  customerGuid,
  taskGuid,
}: UsePostMessageParams) {
  return useMutation({
    mutationFn: async (params: UsePostMessageMutationParams) =>
      await service.sendMessage({ customerGuid, taskGuid, ...params }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['tasks', 'task', taskGuid],
      }),
  });
}

type UseMutationParams = Pick<
  Parameters<typeof service.updateOptions>[number],
  'customerGuid' | 'taskGuid'
>;
type UseMutationMutationParams = Omit<
  Parameters<typeof service.updateOptions>[number],
  'customerGuid' | 'taskGuid'
>;

export function useUpdateOptions({
  customerGuid,
  taskGuid,
}: UseMutationParams) {
  return useMutation({
    mutationFn: async (params: UseMutationMutationParams) =>
      await service.updateOptions({ customerGuid, taskGuid, ...params }),
    onSuccess: () =>
      queryClient.invalidateQueries({
        queryKey: ['tasks', 'task', taskGuid],
      }),
  });
}
